<canvas #canvasDocument class="demo-graphics-view"></canvas>
<div>{{ fps }}</div>
